import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import ModalContainer from "./ModalContainer";

class NewVersionModal extends Component {
    handleRefresh = () => {
        window.location.reload(true);
    };

    render() {
        return (
            <ModalContainer
                open={this.props.open}
                title="New Version Available"
                fullScreen={false}
                maxWidth="xs"
                disableBackdropClick={true}
                disableEscapeKeyDown={true}
            >
                <DialogContent>
                    <DialogContentText>
                        There is a new version of Hot Giggity. Please refresh the page to access the latest version.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        className="btn-confirmation"
                        color="primary"
                        variant="contained"
                        autoFocus
                        onClick={this.handleRefresh}
                    >
                        Refresh Now
                    </Button>
                </DialogActions>
            </ModalContainer>
        );
    }
}

export default NewVersionModal;
